export const customerTableConfig = {
  propList: [
    {prop: 'raffleName', label: '活动名称', minWidth: '80'},
    {prop: 'amount', label: '中奖金额（元）', minWidth: '70'},
    {prop: 'createdTime', label: '中奖时间', minWidth: '120', slotName: 'createdTime'},
    {prop: 'receiveStatus', label: '领取状态', minWidth: '70', slotName: 'receiveStatus'}
  ]
}
